import { Suspense, useContext } from "react";
import { Outlet } from "react-router-dom";
import { Avatar, Box, Flex, IconButton, Spacer, Spinner, Text, useDisclosure } from "@chakra-ui/react";
import { LuRefreshCw } from "react-icons/lu";
import { useActiveAccount } from "applesauce-react/hooks";

import MobileBottomNav from "./bottom-nav";
import MobileHeaderContext, { useMobileHeaderState } from "./mobile-header-context";
import NavDrawer from "./nav-drawer";
import ConnectionStatus from "../components/connection-status";
import { ErrorBoundary } from "../../error-boundary";
import UserAvatar from "../../user/user-avatar";
import useRootPadding from "../../../hooks/use-root-padding";

function MobileTopBar() {
  useRootPadding({ top: "var(--chakra-sizes-12)" });
  const account = useActiveAccount();
  const drawer = useDisclosure();
  const { title, actions } = useContext(MobileHeaderContext);

  return (
    <>
      <Flex
        px="3"
        py="2"
        hideFrom="md"
        position="fixed"
        top="var(--safe-top)"
        left="0"
        right="0"
        zIndex="overlay"
        alignItems="center"
        bg="var(--chakra-colors-chakra-body-bg)"
      >
        {account ? (
          <UserAvatar pubkey={account.pubkey} size="sm" onClick={drawer.onOpen} cursor="pointer" noProxy />
        ) : (
          <Avatar size="sm" src="/apple-touch-icon.png" onClick={drawer.onOpen} cursor="pointer" />
        )}
        {title && (
          <Text fontWeight="bold" fontSize="lg" ml="3">
            {title}
          </Text>
        )}
        <Spacer />
        <ConnectionStatus compact mr="1" />
        <IconButton
          aria-label="Refresh"
          icon={<LuRefreshCw size={14} />}
          size="xs"
          variant="ghost"
          onClick={() => window.location.reload()}
          mr="1"
        />
        {actions}
      </Flex>
      <NavDrawer isOpen={drawer.isOpen} onClose={drawer.onClose} />
    </>
  );
}

export default function MobileLayout() {
  const headerState = useMobileHeaderState();

  return (
    <MobileHeaderContext.Provider value={headerState}>
      <MobileTopBar />
      <Flex flex={1} direction="column" overflow="hidden">
        <Suspense fallback={<Spinner />}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Suspense>
      </Flex>
      <MobileBottomNav />
    </MobileHeaderContext.Provider>
  );
}
